// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "ExpressiveListContainer-module--bx--text-truncate--end--19pNo";
export var bxTextTruncateFront = "ExpressiveListContainer-module--bx--text-truncate--front--2CzE0";
export var container = "ExpressiveListContainer-module--container--3grQS";
export var content = "ExpressiveListContainer-module--content--15EGU";
export var expressive_02 = "ExpressiveListContainer-module--expressive_02--2ha0x";
export var expressive_04 = "ExpressiveListContainer-module--expressive_04--5sh0n";
export var text = "ExpressiveListContainer-module--text--1dhEa";
export var title = "ExpressiveListContainer-module--title--5kF0c";